module.exports = __webpack_public_path__ + "static/media/Sidebar-premium-icon-active.4d897cf0.svg";